import AcionadoService from './../_services/AcionadoService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { acionadoModel } from './../_model/acionado'

const state = {
  loading: false,
  loadingStore: false,
  acionados: [],
  currentPage: null,
  urlFirstPage: null,
  urlNextPage: null,
  urlPrevPage: null,
  urlLastPage: null,
  urlPath: null,
  acionadoSelecionado: undefined,
  erros: '',
  filter: null,
}

const getters = {
  GET_ACIONADOS : (state) => state.acionados,
  GET_URL_PATH : (state) => state.urlPath,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  ACIONADO_SELECTED : (state, { acionado }) => {
    state.acionadoSelecionado = Object.assign({}, acionado)
  },

  MERGE_PESSOA: (state, { pessoa }) => {
    var objOld = Object.assign({}, state.acionadoSelecionado)
    objOld.pessoa = pessoa
    state.acionadoSelecionado = Object.assign({}, objOld)
  },

  SET_ACIONADOS : (state, { acionados }) => {
    state.acionados = JSON.parse(JSON.stringify(acionados))
    state.urlFirstPage = acionados.first_page_url
    state.urlPrevPage = acionados.prev_page_url
    state.urlPrevPage = acionados.prev_page_url
    state.urlLastPage = acionados.last_page_url
    state.urlPath = acionados.path
    state.currentPage = acionados.current_page
  },

  SET_FILTER: (state, filter) => {
    state.filter = filter
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.acionadoSelecionado = undefined,

}

const actions = {

  GET_ACIONADOS : async ({ commit, state }) => {
      commit('SET_ACIONADOS', { acionados : []})
      commit('ERASE_ERROS')
      await AcionadoService.getAcionados(state.filter)
      .then(response => {
        if (response.data.status) {
          commit('SET_ACIONADOS', { acionados : response.data.acionados })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      })
  },

  PAGINATE_ACIONADOS : async ({ commit }, url) => {
    commit('ERASE_ERROS')
    await AcionadoService.getPagination(url)
    .then(response => {
      if (response.data.status) {
        commit('SET_ACIONADOS', { acionados : response.data.acionados })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })
  },

  GET_ACIONADO : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await AcionadoService.getAcionado(id)
    .then(response => {
      if (response.data.status) {
        commit('ACIONADO_SELECTED', { acionado : response.data.acionado })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })

  },

  GET_CPFCNPJ : async ({commit}, cpfcnpj) => {
    commit('ERASE_ERROS')
    if (!cpfcnpj) return
    await AcionadoService.getCpfCnpj(cpfcnpj)
    .then(response => {
      if (response.data.status) {
        var data = response.data
        if (data.acionado) {
          commit('ACIONADO_SELECTED', { acionado : response.data.acionado })
        } else if (data.pessoa) {
          commit('MERGE_PESSOA', { pessoa: data.pessoa })
        }
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })
  },

  STORE_ACIONADO : async ({ commit, dispatch }, acionado) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!acionado.id || !(acionado.id > 0)) { 
        var response = await AcionadoService.postAcionado(acionado)
      } else {
        var response = await AcionadoService.putAcionado(acionado.id, acionado)
      }

      if (response.data.status) {
        commit('ACIONADO_SELECTED', { acionado : response.data.acionado })
        if (state.urlPrevPage || state.urlNextPage) {
          await dispatch('PAGINATE_ACIONADOS', `${state.urlPath}?page=${state.currentPage}`)
        } else {
          await dispatch('GET_ACIONADOS')
        }

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_ACIONADO : async ({ commit, dispatch }, acionado) => {
    commit('ERASE_ERROS')
    try {
      var response = await AcionadoService.deleteAcionado(acionado.id)

      if (response.data.status) {
        await dispatch('GET_ACIONADOS')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  ACIONADO_SELECTED : async ({dispatch, commit}, id) => { 
    if (id > 0) { 
      await dispatch('GET_ACIONADO', id)
    } else {
      var obj = new acionadoModel.acionado()
      await commit('ACIONADO_SELECTED', { acionado: obj })
    }
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Acionado/_store/index.js